import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from '../../components/feature/Navigation';
import CinematicIntro from './components/CinematicIntro';
import HeroSection from './components/HeroSection';
import CompanyIntro from './components/CompanyIntro';
import ServicesReveal from './components/ServicesReveal';
import IndustrialSectors from './components/IndustrialSectors';
import ProcessCinematic from './components/ProcessCinematic';
import ContactSection from './components/ContactSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const [showIntro, setShowIntro] = useState(true);
  const [introComplete, setIntroComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIntro(false);
      setTimeout(() => setIntroComplete(true), 1000);
    }, 4500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {showIntro && <CinematicIntro key="intro" />}
      </AnimatePresence>

      {introComplete && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <Navigation />
          <HeroSection />
          <CompanyIntro />
          <ServicesReveal />
          <IndustrialSectors />
          <ProcessCinematic />
          <ContactSection />
          <Footer />
        </motion.div>
      )}
    </>
  );
}
